/**
 * Type definitions and enums for Start.ng player identity and character styling.
 */

export const SUPPORTED_STYLES = {
  BODIES: ['female', 'male'],
  HAIRSTYLES: ['short', 'afro', 'braids', 'bun', 'ponytail', 'dreads', 'bald'],
  HATS: ['none', 'cap', 'beanie', 'tophat', 'crown'],
  ACCESSORIES: ['none', 'glasses', 'earrings', 'beard', 'scarf', 'backpack'],
};

export const DEFAULT_STYLE = {
  body: 'male',
  primaryColor: '#4b7bec',
  secondaryColor: '#2b2f4a',
  skinColor: '#8d5524',
  hairColor: '#17120f',
  hair: 'short',
  hat: 'none',
  accessory: 'none',
};

export const GUEST_STYLE = {
  body: 'male',
  primaryColor: '#20bf6b',
  secondaryColor: '#1b2a47',
  skinColor: '#d6a374',
  hairColor: '#303030',
  hair: 'short',
  hat: 'cap',
  accessory: 'none',
};
